import { render } from "./ConfirmModal.vue?vue&type=template&id=0bab022c&scoped=true&bindings={\"close\":\"options\"}"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import "./ConfirmModal.vue?vue&type=style&index=0&id=0bab022c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bab022c"

export default script